/* eslint-disable max-len */
import React from 'react';

/**
 * Whiteboard icon matching the jitsi-meet whiteboard icon.
 *
 * @returns {ReactElement}
 */
export default function WhiteboardIcon() {
    return (
        <svg
            height = '24'
            viewBox = '0 0 24 24'
            width = '24'
            xmlns = 'http://www.w3.org/2000/svg'>
            <path
                d = 'M21 3.75H3V14.25H21V3.75ZM3 2.25C2.17157 2.25 1.5 2.92157 1.5 3.75V14.25C1.5 15.0784 2.17157 15.75 3 15.75H21C21.8284 15.75 22.5 15.0784 22.5 14.25V3.75C22.5 2.92157 21.8284 2.25 21 2.25H3Z'
                fill = 'currentColor'
                fillRule = 'evenodd' />
            <path
                d = 'M9.3046 14.3146C9.68312 14.4829 9.85359 14.9261 9.68536 15.3046L6.68536 22.0546C6.51713 22.4331 6.07391 22.6036 5.6954 22.4354C5.31688 22.2671 5.14641 21.8239 5.31464 21.4454L8.31464 14.6954C8.48287 14.3169 8.92609 14.1464 9.3046 14.3146Z'
                fill = 'currentColor'
                fillRule = 'evenodd' />
            <path
                d = 'M14.6954 14.3146C14.3169 14.4829 14.1464 14.9261 14.3146 15.3046L17.3146 22.0546C17.4829 22.4331 17.9261 22.6036 18.3046 22.4354C18.6831 22.2671 18.8536 21.8239 18.6854 21.4454L15.6854 14.6954C15.5171 14.3169 15.0739 14.1464 14.6954 14.3146Z'
                fill = 'currentColor'
                fillRule = 'evenodd' />
        </svg>
    );
}
